function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function BinIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M17.9622 8.5H19.9664L19.1299 20.2139C19.0176 21.7764 17.7031 23 16.1377 23H7.8623C6.29687 23 4.98242 21.7764 4.87011 20.2139L4.03356 8.5H6.03783L6.86425 20.0713C6.90234 20.5918 7.33984 21 7.8623 21H16.1377C16.6601 21 17.0977 20.5918 17.1357 20.0713L17.9622 8.5ZM22 5V7H2V5H7.27899L8.6123 1H15.3877L16.721 5H22H22ZM14.6123 5L13.9463 3H10.0537L9.38768 5H14.6123H14.6123Z",
    fill: "currentColor"
  }));
}
export function BinIconSmall(props) {
  return ___EmotionJSX(BinIcon, _extends({
    size: "small"
  }, props));
}